import React from "react";
import { Outlet, NavLink } from "react-router-dom";

const tabs = [
  { to: "/", label: "Record", icon: "fa-microphone", testId: "tab-record" },
  { to: "/history", label: "History", icon: "fa-clock-rotate-left", testId: "tab-history" },
  { to: "/summary", label: "Summary", icon: "fa-wand-magic-sparkles", testId: "tab-summary" },
  { to: "/profile", label: "Profile", icon: "fa-user", testId: "tab-profile" },
];

export default function AppShell() {
  return (
    <div className="min-h-screen bg-slate-900 text-slate-100 flex flex-col">
      {/* Top notch / ambient blobs background */}
      <div className="pointer-events-none fixed inset-0 overflow-hidden z-0">
        <div className="absolute -top-32 -left-24 w-80 h-80 bg-blue-600/15 rounded-full blur-3xl blob"></div>
        <div className="absolute top-1/3 -right-24 w-72 h-72 bg-violet-600/15 rounded-full blur-3xl blob" style={{ animationDelay: "4s" }}></div>
      </div>

      <main className="relative z-10 flex-1 safe-top pb-[calc(74px+env(safe-area-inset-bottom,0px))]">
        <Outlet />
      </main>

      {/* Bottom Tab Bar */}
      <nav
        data-testid="bottom-tabs"
        className="fixed bottom-0 left-0 right-0 z-[10000] glass border-t border-slate-700/60 safe-bottom"
      >
        <div className="max-w-2xl mx-auto grid grid-cols-4 px-2 pt-1">
          {tabs.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.to === "/"}
              data-testid={t.testId}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center py-2.5 rounded-xl btn-press transition-colors ${
                  isActive ? "text-blue-400" : "text-slate-500 hover:text-slate-300"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <div className={`relative w-11 h-7 flex items-center justify-center ${isActive ? "scale-110" : ""} transition-transform`}>
                    {isActive && (
                      <span className="absolute inset-0 -top-1 mx-auto w-10 h-10 rounded-full bg-blue-500/10 blur-sm"></span>
                    )}
                    <i className={`fas ${t.icon} text-lg relative`}></i>
                  </div>
                  <span className="text-[11px] font-medium mt-0.5">{t.label}</span>
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
